import { Language, Provider } from '@cartodb/workflows-engine'
import { sqlQueryExecutor } from './index'
import { JobSqlQueryExecutor } from './JobSqlQueryExecutor'
import { jobsClient } from '../clients/JobsClient'
import { getStore } from 'app/state/storeRegistry'
import { Workflow } from '../../types'
import { isEmpty } from 'lodash'

interface OptionParams {
  returnResults?: boolean
  signal?: AbortSignal
  language?: Language
  workflow?: Workflow
  createJob?: boolean
}

export class DataSyncManager {
  async sync<T>(query: string, options?: OptionParams): Promise<T> {
    // TODO not using WorkflowStoreManager to avoid wrong coupling of classes
    // WorkflowManager (WorkflowStoreManager) <- ReduxManager (setters & getters)
    // DataSyncManager <- ReduxManager (setters & getters)
    const workflow = options?.workflow || getStore().getState().workflows.workflow

    // This will be used when the createJob option is true and always for Databricks
    if (options?.createJob || workflow?.config?.connectionProvider === Provider.DatabricksRest) {
      return new JobSqlQueryExecutor(jobsClient, {
        language: options?.language ?? Language.Python,
        signal: options?.signal,
        returnResults: options?.returnResults
      }).execute(query) as unknown as Promise<T>
    }

    return sqlQueryExecutor.execute(query, workflow.connectionName, {
      retry: 3,
      options: options,
      signal: options?.signal
    })
  }

  async syncAll<T>(queries: string[], options?: OptionParams) {
    // This function requires allowing multiple queries with return in the SQL API.
    // Now, it only allows multiple queries without returning the result when the param
    // returnResults is false: https://github.com/CartoDB/cloud-native/pull/10555.
    // Redshift/Postgres limitation: "cannot insert multiple commands into a prepared statement".
    // With this approach, we run multiple queries and keep the last non empty response.
    const responses = [] as T[]

    const queriesToExecute = queries.filter(Boolean)
    for (const query of queriesToExecute) {
      responses.push(await this.sync<T>(query, options))
    }

    return responses.reverse().find((item) => !isEmpty(item)) || []
  }
}
